import { createSelector, createSelectorMemoized } from "../../../utils/createSelector.es.js";
import { gridRowsLookupSelector } from "../rows/gridRowsSelector.es.js";
const gridRowSelectionStateSelector = (state) => state.rowSelection;
const selectedGridRowsCountSelector = createSelector(gridRowSelectionStateSelector, (selection) => selection.length);
const selectedGridRowsSelector = createSelectorMemoized(gridRowSelectionStateSelector, gridRowsLookupSelector, (selectedRows, rowsLookup) => new Map(selectedRows.map((id) => [id, rowsLookup[id]])));
const selectedIdsLookupSelector = createSelectorMemoized(gridRowSelectionStateSelector, (selection) => selection.reduce((lookup, rowId) => {
  lookup[rowId] = rowId;
  return lookup;
}, {}));
export {
  gridRowSelectionStateSelector,
  selectedGridRowsCountSelector,
  selectedGridRowsSelector,
  selectedIdsLookupSelector
};
//# sourceMappingURL=gridRowSelectionSelector.es.js.map
